export var AppointmentCancellationReason;
(function (AppointmentCancellationReason) {
    AppointmentCancellationReason["CustomerNotResponding"] = "CUSTOMER_NOT_RESPONDING";
    AppointmentCancellationReason["ExploringOptions"] = "EXPLORING_OPTIONS";
    AppointmentCancellationReason["HappyWithCurrentBankAndRates"] = "HAPPY_WITH_CURRENT_BANK_AND_RATES";
    AppointmentCancellationReason["ServicingIncomeOrEmployment"] = "SERVICING_INCOME_OR_EMPLOYMENT";
    AppointmentCancellationReason["DuplicatedAppointment"] = "DUPLICATED_APPOINTMENT";
    AppointmentCancellationReason["CreditIssues"] = "CREDIT_ISSUES";
    AppointmentCancellationReason["LowRefinanceLvr"] = "LOW_REFINANCE_LVR";
    AppointmentCancellationReason["InsufficientDeposit"] = "INSUFFICIENT_DEPOSIT";
    AppointmentCancellationReason["InsufficientExitStrategy"] = "INSUFFICIENT_EXIT_STRATEGY";
    AppointmentCancellationReason["PurchasingAfterThreeMonths"] = "PURCHASING_AFTER_THREE_MONTHS";
    AppointmentCancellationReason["PendingLegalMatter"] = "PENDING_LEGAL_MATTER";
})(AppointmentCancellationReason || (AppointmentCancellationReason = {}));
//# sourceMappingURL=AppointmentCancellationReason.js.map